import { Box } from '@/src/packages/components/ui/Box';
import { ReactNode } from 'react';

export const ProductOptionHeading = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      className="leading-none"
      display="flex"
      alignItems="center"
      fontWeight="medium"
      marginBottom={3}
    >
      {children}
    </Box>
  );
};
